import { FaChartLine, FaBullseye, FaShieldAlt, FaLock, FaHandshake } from 'react-icons/fa';

function ClientAssessmentSection({ buyLink, onBuyClick }) {
  const features = [
    {
      icon: <FaChartLine className="text-4xl sm:text-5xl lg:text-6xl text-amber-400" />,
      title: "Client Roi / Profit calculation system",
      subtitle: "Per Invoice Profit"
    },
    {
      icon: <FaBullseye className="text-4xl sm:text-5xl lg:text-6xl text-amber-400" />,
      title: "Bad / Slow paying client filtering system",
      subtitle: ""
    },
    {
      icon: <FaShieldAlt className="text-4xl sm:text-5xl lg:text-6xl text-amber-400" />,
      title: "Fraud Prevention",
      subtitle: "Security Measures"
    },
    {
      icon: <FaLock className="text-4xl sm:text-5xl lg:text-6xl text-amber-400" />,
      title: "Credit Insurance",
      subtitle: "Risk Mitigation"
    },
   
  ];

  return (
    <section className="relative py-24 px-4 sm:px-8 bg-slate-800 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {/* CTA Button */}
        <div className="text-center mb-14">
          <button 
            onClick={onBuyClick}
            className="inline-block bg-gradient-to-r from-amber-400 via-amber-500 to-orange-500 text-slate-900 px-12 sm:px-20 py-4 sm:py-5 rounded-xl text-lg sm:text-2xl font-extrabold shadow-[0_10px_20px_-5px_rgba(251,191,36,0.4)] hover:shadow-[0_20px_30px_-8px_rgba(251,191,36,0.5)] hover:-translate-y-0.5 transition-all duration-200 tracking-wide cursor-pointer"
          >
            Book a call →
          </button>
        </div>

     

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6 lg:gap-5 max-w-7xl mx-auto">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group bg-gradient-to-br from-slate-700/50 to-slate-800/50 rounded-2xl p-6 sm:p-7 lg:p-8 text-center border border-slate-600/50 hover:border-amber-500/50 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_15px_30px_-5px_rgba(251,191,36,0.2)]"
            >
              {/* Icon */}
              <div className="w-20 h-20 sm:w-24 sm:h-24 mx-auto mb-5 rounded-2xl bg-gradient-to-br from-slate-700 to-slate-800 flex items-center justify-center shadow-lg group-hover:scale-105 transition-transform duration-300 border border-amber-500/20">
                {feature.icon}
              </div>

              {/* Title */}
              <div className="text-base sm:text-lg lg:text-xl text-white font-bold mb-2 leading-tight min-h-[60px] flex items-center justify-center">
                {feature.title}
              </div>
              
              {/* Subtitle */}
              {feature.subtitle && (
                <div className="text-sm sm:text-base text-slate-400 font-medium">
                  {feature.subtitle}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ClientAssessmentSection;
